import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { RouterAuthEnum } from '../enums/router-link.enum';
import { Environment } from '../../core/interfaces/environment';

export const openIdConfigurationFactory = (environment: Environment): OpenIdConfiguration => {
  return {
    authority: environment.authorityUrl,
    // TODO: replace with preper Client configuration
    redirectUrl: `${window.location.origin}/${RouterAuthEnum.Callback}`,
    postLogoutRedirectUri: `${window.location.origin}/${RouterAuthEnum.LoggedOut}`,
    clientId: environment.identityClientId,
    // TODO: request a new Lexipoort OpenID Connect client
    scope: 'openid profile email offline_access licensedetails',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    logLevel: LogLevel.Debug
  };
};
